import { render, staticRenderFns } from "./nurseresolution.vue?vue&type=template&id=3a67ee39&scoped=true&"
import script from "./nurseresolution.vue?vue&type=script&lang=js&"
export * from "./nurseresolution.vue?vue&type=script&lang=js&"
import style0 from "./nurseresolution.vue?vue&type=style&index=0&id=3a67ee39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67ee39",
  null
  
)

export default component.exports